<template>
  <header class="masthead">
    <div
      class="container px-4 px-lg-5 d-flex h-100 align-items-center justify-content-center"
    >
      <div class="d-flex justify-content-center">
        <div class="text-center">
          <img
            src="@/assets/img/ironwood-logo.svg"
            alt=""
            class="d-block mx-auto mb-4"
            style="
              height: 8em;
              filter: invert(99%) sepia(1%) saturate(991%) hue-rotate(299deg)
                brightness(112%) contrast(100%);
            "
          />
          <h1 class="mx-auto my-0">ironwood flutes</h1>
          <h2 class="text-white-50 mx-auto mt-3">
            handcrafted flutes, headjoints &amp; whistles from the Eifel
          </h2>
          <a
            href="/#contact"
            class="btn btn-outline-light rounded-pill mt-5 px-4 py-2"
            style="
              border: 1px solid rgba(255, 255, 255, 0.5);
              text-transform: none;
              letter-spacing: normal;
            "
            >get in touch</a
          >
        </div>
      </div>
    </div>
  </header>
</template>
<script lang="ts">
export default {
  name: "MastHeadSectionComponent",
};
</script>
